module.exports = __webpack_public_path__ + "static/media/BZ.c6b9ed7b.svg";